import api from './client';

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
};

export const usersApi = {
  list: () => api.get('/users').then(r => r.data),
  options: () => api.get('/users/options').then(r => r.data),
  create: (body) => api.post('/users', body).then(r => r.data),
  update: (id, body) => api.patch(`/users/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/users/${id}`).then(r => r.data),
  rolePresets: () => api.get('/permissions/roles').then(r => r.data),
};

export const leadsApi = {
  list: (params = {}) => api.get('/leads', { params }).then(r => r.data),
  create: (body) => api.post('/leads', body).then(r => r.data),
  update: (id, body) => api.patch(`/leads/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/leads/${id}`).then(r => r.data),
  getActivity: (id)        => api.get(`/leads/${id}/activities`).then(r => r.data),
  addActivity: (id, body)  => api.post(`/leads/${id}/activities`, body).then(r => r.data),
  printReport: (body) => api.post('/leads/print-report', body).then(r => r.data),
};

export const contactsApi = {
  list: () => api.get('/contacts').then(r => r.data),
  create: (body) => api.post('/contacts', body).then(r => r.data),
  update: (id, body) => api.patch(`/contacts/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/contacts/${id}`).then(r => r.data),
};

export const propertiesApi = {
  list: () => api.get('/properties').then(r => r.data),
  create: (body) => api.post('/properties', body).then(r => r.data),
  update: (id, body) => api.patch(`/properties/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/properties/${id}`).then(r => r.data),
  uploadBrochure: (id, formData) => api.post(`/properties/${id}/brochure`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data),
  removeBrochure: (id) => api.delete(`/properties/${id}/brochure`).then(r => r.data),
};

export const dealsApi = {
  list: () => api.get('/deals').then(r => r.data),
  create: (body) => api.post('/deals', body).then(r => r.data),
  update: (id, body) => api.patch(`/deals/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/deals/${id}`).then(r => r.data),
};

export const tasksApi = {
  list: () => api.get('/tasks').then(r => r.data),
  create: (body) => api.post('/tasks', body).then(r => r.data),
  update: (id, body) => api.patch(`/tasks/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/tasks/${id}`).then(r => r.data),
};

export const callsApi = {
  list: () => api.get('/calls').then(r => r.data),
  create: (body) => api.post('/calls', body).then(r => r.data),
  remove: (id) => api.delete(`/calls/${id}`).then(r => r.data),
};

export const visitsApi = {
  list: () => api.get('/site-visits').then(r => r.data),
  create: (body) => api.post('/site-visits', body).then(r => r.data),
  update: (id, body) => api.patch(`/site-visits/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/site-visits/${id}`).then(r => r.data),
};

export const dashboardApi = {
  stats: () => api.get('/dashboard/stats').then(r => r.data),
  cards: (params = {}) => api.get('/dashboard/cards', { params }).then(r => r.data),
};

export const activitiesApi = {
  forLead: (leadId) => api.get(`/leads/${leadId}/activities`).then(r => r.data),
  add: (leadId, body) => api.post(`/leads/${leadId}/activities`, body).then(r => r.data),
  whatsapp: (leadId, body) => api.post(`/leads/${leadId}/whatsapp`, body).then(r => r.data),
};

export const coordinatorApi = {
  assign: (propId, coordinator) => api.patch(`/properties/${propId}/coordinator`, { coordinator }).then(r => r.data),
};

export const rolesApi = {
  create: (name, permissions) => api.post('/roles', { name, permissions }).then(r => r.data),
  remove: (name) => api.delete(`/roles/${encodeURIComponent(name)}`).then(r => r.data),
};

export const adminApi = {
  cleanupDemoData: () => api.post('/admin/cleanup-demo-data').then(r => r.data),
  releaseDemoUnits: () => api.post('/admin/release-demo-units').then(r => r.data),
};

export const greetingsApi = {
  upcoming: (days = 30) => api.get('/greetings/upcoming', { params: { days } }).then(r => r.data),
  log: () => api.get('/greetings/log').then(r => r.data),
  run: () => api.post('/greetings/run').then(r => r.data),
};

export const aiApi = {
  latest: (leadId) => api.get(`/leads/${leadId}/ai-insights`).then(r => r.data),
  generate: (leadId) => api.post(`/leads/${leadId}/ai-insights`).then(r => r.data),
};

export const metaApi = {
  status: () => api.get('/meta/status').then(r => r.data),
  retryPending: () => api.post('/meta/retry-pending').then(r => r.data),
};

export const integrationsApi = {
  whatsappStatus: () => api.get('/integrations/whatsapp/status').then(r => r.data),
  whatsappTestSend: (body) => api.post('/integrations/whatsapp/test-send', body).then(r => r.data),
};

export const unitsApi = {
  list: (params = {}) => api.get('/units', { params }).then(r => r.data),
  create: (body) => api.post('/units', body).then(r => r.data),
  bulk: (body) => api.post('/units/bulk', body).then(r => r.data),
  update: (id, body) => api.patch(`/units/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/units/${id}`).then(r => r.data),
};

export const bookingsApi = {
  list: (params = {}) => api.get('/bookings', { params }).then(r => r.data),
  get: (id) => api.get(`/bookings/${id}`).then(r => r.data),
  create: (body) => api.post('/bookings', body).then(r => r.data),
  update: (id, body) => api.patch(`/bookings/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/bookings/${id}`).then(r => r.data),
  loanActivity: (id) => api.get(`/bookings/${id}/loan-activity`).then(r => r.data),
  addLoanActivity: (id, body) => api.post(`/bookings/${id}/loan-activity`, body).then(r => r.data),
};

export const installmentsApi = {
  list: (params = {}) => api.get('/installments', { params }).then(r => r.data),
  update: (id, body) => api.patch(`/installments/${id}`, body).then(r => r.data),
  pay: (id, body) => api.post(`/installments/${id}/pay`, body).then(r => r.data),
  remind: (id) => api.post(`/installments/${id}/remind`).then(r => r.data),
  summary: () => api.get('/payments/summary').then(r => r.data),
  runReminders: () => api.post('/payments/run-reminders').then(r => r.data),
};

export const documentsApi = {
  types: () => api.get('/documents/types').then(r => r.data),
  list: (params = {}) => api.get('/documents', { params }).then(r => r.data),
  add: (body) => api.post('/documents', body).then(r => r.data),
  update: (id, body) => api.patch(`/documents/${id}`, body).then(r => r.data),
  remove: (id) => api.delete(`/documents/${id}`).then(r => r.data),
  upload: (formData) => api.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data),
};
